import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-edit-docs',
  templateUrl: './edit-docs.component.html',
  styleUrls: ['./edit-docs.component.scss']
})
export class EditDocsComponent implements OnInit {

  @Input() data: any;
  @Input() schema: any;
  columns: string [] = [];
  constructor() { }

  async ngOnInit() {
    this.getItems();
  }
  saveApi() {
  }
  deletearrayColumn(a, column) {
    if (this.data[column].length > 1) {
      this.data[column].splice(a, 1);
    }
  }
  getItems() {
    for (const itemval in this.data) {
      this.columns.push(itemval);
    }
  }
  saveDescription(attr, column, value) {
    attr[column] = value;
  }
  addColumn(data) {
    let temp = JSON.parse(JSON.stringify(this.schema));
    data.push(temp);
  }
  typeof(object) {
    let stringConstructor = 'test'.constructor;
    let arrayConstructor = [].constructor;
    let objectConstructor = ({}).constructor;

    if (object === null) {
      return 'null';
    }
    if (object === undefined) {
      return 'undefined';
    }
    if (object.constructor === stringConstructor) {
      return 'String';
    }
    if (object.constructor === arrayConstructor) {
      return 'array';
    }
    if (object.constructor === objectConstructor) {
      return 'object';
    }
    {
      return 'don\'t know';
    }
  }
  stringifyjson(val) {
    return JSON.stringify(val);
  }
}

